import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Button, Col, DropdownItem, Input, Label, Row } from 'reactstrap';
import { Modal } from '../../../../Components/Custom/modal';
import { useAppDispatch } from '../../../../app/hooks';
import { handleMultipleModalsWithOneState } from '../../../../helpers/helpers';
import { createOrder, updatePackageStatus } from '../slice';
import { CalculationStatus, OpenedModal } from '../types';
import Select from 'react-select';

export const CreateOrderModal: FC<{
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  id: number;
  setId: Dispatch<SetStateAction<number>>;
  product: any;
  setProduct: any;
  params: URLSearchParams;
}> = ({ isOpen, setIsOpen, id, setId, product, setProduct, params }) => {
  const dispatch = useAppDispatch();

  const options = [
    { value: 355, label: 'Starter' },
    { value: 350, label: 'Basic' },
    { value: 351, label: 'Builder' },
    { value: 352, label: 'Pro' },
    { value: 353, label: 'Elite' },
    { value: 390, label: 'P Basic' },
    { value: 391, label: 'P Builder' },
    { value: 392, label: 'P Pro' },
    { value: 393, label: 'P Elite' },
    { value: 356, label: 'Access' },
    { value: 357, label: 'Builder 300' }
  ];

  const onSubmit = () => {
    setIsOpen(!isOpen);
    dispatch(createOrder({ id, productId: product.value, params }));
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(!isOpen)}
      title={'Create Order'}
      actions={
        <>
          <Button
            color='primary'
            outline
            onClick={() => setIsOpen(false)}
            className='m-1'>
            Cancel
          </Button>
          <Button
            color='primary'
            className='m-1'
            onClick={onSubmit}
            disabled={!id || !product}>
            Create
          </Button>
        </>
      }>
      <Col lg={12}>
        <Row>
          <Col lg={12}>
            <Label className='w-100 text-left' for='userId'>
              User ID
            </Label>
            <Input
              id='userId'
              className='w-100 mb-2'
              type='number'
              value={id}
              onChange={(e) => setId(parseInt(e.target.value))}
              placeholder='Enter here'
            />
          </Col>
        </Row>
        <Row>
          {/* <Select options={options} /> */}
          <Label className='w-100 text-left mt-3' for='userId'>
            Products
          </Label>
          <Select
            // value={getValue}
            onChange={(e: any) => setProduct(e)}
            options={options}
            placeholder={'Select Product'}
          />
        </Row>
      </Col>
    </Modal>
  );
};
